import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const FullContdown: FC = () => {
  const ClientName = useSelector(
    (state: RootState) => state.client.userCompany
  );
  const templateId = useSelector(
    (state: RootState) => state.template.templateId
  );
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const yearTitleFontURL = getFontURL(fontFamily?.year_title);
  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const countdownTitleFontURL = getFontURL(fontFamily?.countdown_title);
  const countdownFontURL = getFontURL(fontFamily?.countdown);
  const btnFontURL = getFontURL(btnFontFamily?.button);
  // const yearTitleFontURL = `https://workspace.inappmessage.com/${ClientName}/font/${fontFamily?.year_title}`;
  // const titleFontURL = `https://workspace.inappmessage.com/${ClientName}/font/${fontFamily?.title}`;
  // const subTitleFontURL = `https://workspace.inappmessage.com/${ClientName}/font/${fontFamily?.sub_title}`;
  // const countdownTitleFontURL = `https://workspace.inappmessage.com/${ClientName}/font/${fontFamily?.countdown_title}`;
  // const countdownFontURL = `https://workspace.inappmessage.com/${ClientName}/font/${fontFamily?.countdown}`;
  // const btnFontURL = `https://workspace.inappmessage.com/${ClientName}/font/${btnFontFamily?.button}`;

  const closeImageUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABaUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4eHh8fHy0tLS4uLqamprW1teLi4uPj4/Ly8oZg+lAAAAAUdFJOUwAQIDBAUF9gb3CPkJ+gr7C/z9/vMBy4TQAAAvhJREFUaN7FmtuaqyAMhYO1ZVMdR2H1LO//mvvCdkZbhITSb9Ztdf2VQAgHIpZUbfbdYB0AONt3e1MrKiWlW4uAhlZXBdxNj4j6Nxl11H1St83/8xYsWZ3l/8+BrQxEbSGSEFF1EKsVhHvnkCH2R6g9MrVnDb7KIluW0UwbhzdkN8nmx5vaJTo/3pb5sH+UsEMRrbbSBoW0Kd8/l3LB3qqK+QM2NOL2KKj9q79GUe0+F4CVMLQorO6jDQQA9QIQaKDjdfSXY9po7Tmb+IDj6L334znlf56eO8ZTRuADLt5zCJO/99dAnFU0At5zCA9/P0azXqiLjhzCj7/3iERhG3r36tOEmf8l1pGCNcphTBJm/rdDsHK9D+Lk62HC3P8U9lDRQZYgMPzvYe6RQ+D4T21UsTrJM4HlP7WRRgaB6Q+dyqMrBK4/WiIaICaw/WGJFCAl8P0BRTWkBIk/ajIQEkT+MNRARpD5oyHOYmlOkPnjmxgr4QVB5o+BeOXKK4HnD0vMBc0zgekPR9wqZEng+gNswILA988EpKsZOWDZRHxCbpC5BJfdTZkEm8jWkYHGI/TSVHEbZYRvYbK7nc4yQiNL17cTo156Ste10F9IqCVT5mP8SgiKEv00OL/wCQMRfYn9BYSWX3gt8xuXoClat0TmXyah4ha/r/mZRZgWCCbHn0eYNjpVlj+LcN9PCLbRMV2fzAnHcCK671OHfrww5scZ4Rr6fRtbxrLm31/CGFvGBsM8sub3X8JqiImIlFtdJ6fqhwfhEt8NMWvr5HR9MhFC62Sd2M45XPztekhPKWvP2eWBR/kNqafThK60f/u8KejK+r+eJOiPNhARccoLvpq/2FouGIa1o5xPb+8XC3TkPM2U8I8e4pgP+xdopeR54+at3uo2f3/USKSyx3TDvamgsz7CCc6sqy+5fye7nyD9CFuLT/UlCGey7iVwEdZkX0PZMmbSvqZ3VOn41RNT4A5Npb+C2wG21QVv6NSm6frH9Z+ha9jXf/4D6/hXXVtJWDsAAAAASUVORK5CYII=';
  const style = `
  @font-face {
    font-family: 'yearTitleFont';
    src: url(${yearTitleFontURL});
    }
  @font-face {
    font-family: 'titleFont';
    src: url(${titleFontURL});
    }
  @font-face {
    font-family: 'subTitleFont';
    src: url(${subTitleFontURL});
    }
  @font-face {
    font-family: 'countdownTitleFont';
    src: url(${countdownTitleFontURL});
    }
  @font-face {
    font-family: 'countdownFont';
    src: url(${countdownFontURL});
    }
  @font-face {
    font-family: 'btnFont';
    src: url(${btnFontURL});
    }

    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };
      width: 100%;
      height: 100%;

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;
    }
    .content_wrapper {
      width: 100%;
      height: 100%;
      padding: 0 10%;
    }

    .close_btn {
      position: absolute;
      right: 10%;
      top: 6%;
    }
    .close_btn button {
      width: 1.5rem;
      height: 1.5rem;
      
      background-image: url(${closeImageUrl});
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }
    
    .center {
      width: 100%;
      height: 100%;
      
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
      padding: 0 10%;
    }

    .title_wrapper {
      width: 100%;
      display: flex;

      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
    }
    .title_wrapper .year {
      width: 100%;
      height: 1.25rem;
      text-align: ${textAlign?.year_title};

      font-size: ${fontSize?.year_title}rem;
      font-weight: ${fontWeight?.year_title};
      color: ${color?.year_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.year_title
        )
          ? fontFamily?.year_title
          : 'yearTitleFont'
      } !important;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .title_wrapper .title {
      width: 100%;
      height: 3rem;
      text-align: ${textAlign?.title};
      
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      color: ${color?.title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.title
        )
          ? fontFamily?.title
          : 'titleFont'
      } !important;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .title_wrapper .sub_title {
      width: 100%;
      height: 4rem;
      text-align: ${textAlign?.sub_title};

      font-size: ${fontSize?.sub_title}rem;
      font-weight: ${fontWeight?.sub_title};
      color: ${color?.sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.sub_title
        )
          ? fontFamily?.sub_title
          : 'subTitleFont'
      } !important;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }

    .timer_area {
      width: 100%;
      display: flex;

      flex-direction: column;
      gap: 0.5rem;
    }
    .timer_area .countdown_text {
      width: 100%;
      height: 1.5rem;
      text-align: ${textAlign?.countdown_title};

      font-size: ${fontSize?.countdown_title}rem;
      font-weight: ${fontWeight?.countdown_title};
      color: ${color?.countdown_title};
     
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.countdown_title
        )
          ? fontFamily?.countdown_title
          : 'countdownTitleFont'
      } !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .timer_area .timer {
      height: 6.25rem;

      display: grid;
      grid-template-columns: 1fr 1rem 1fr 1rem 1fr;
      justify-content: space-between;
    }
    .timer_area li {
      list-style: none;
      text-align: ${textAlign?.countdown};

      font-size: ${fontSize?.countdown}rem;
      font-weight: ${fontWeight?.countdown};
      color: ${color?.countdown};
      font-family: ${fontFamily?.countdown} !important;
    }
    .timer_area .en {
      display: block;
      font-size: 1.25rem;
      font-weight: 400;
      font-family: ${fontFamily?.countdown} !important;
    }
    .timer_area .finish_ment {
      height: 5rem;

      display: flex;
      justify-content: center;
      align-items: center;

      white-space: pre-line;
      font-size: 1.25rem;
      font-weight: ${btnFontWeight?.sub_button};
      color: rgba(255, 255, 255, 0);
    }

    .btn_bottom {
      width: 100%;
      padding: 0 10%;
      position: absolute;
      left: 0;
      bottom: 48px;
    }
    .btn_bottom button {
      width: 100%;
      height: 3rem;
      padding: 0 1rem;
      border: none;
      display: block;
      text-align: center;
    }
    .btn_bottom .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      cursor: pointer;
      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      color: ${btnColor?.button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.button
        )
          ? btnFontFamily?.button
          : 'btnFont'
      } !important;
      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
     }

    @media screen and (min-width: 608px) and (max-width: 1024px) {
      .content_wrapper {
        padding: 0 25%;
      }
      .close_btn {
        right: 25%;
        top: 4rem;
      }

      .title_wrapper,
      .timer_area,
      .center {
        gap: 1rem;
      }
      .title_wrapper .year {
        height: 1.8125rem;
        font-size: ${fontSize?.year_title + 0.5}rem;
      }
      .title_wrapper .title {
        height: 4rem;
        font-size: ${fontSize?.title + 1}rem;
      }
      .title_wrapper .sub_title {
        height: 5rem;
        font-size: ${fontSize?.sub_title + 1}rem;
        -webkit-line-clamp: 2;
      }

      .timer_area .timer {
        height: 8.125rem;
      }
      .timer_area .countdown_text {
        height: 2rem;
        font-size: ${fontSize?.countdown_title + 0.5}rem;
      }
      .timer_area li {
        font-size: ${fontSize?.countdown + 1.5}rem;
      }

      .btn_bottom {
        padding: 0 25%;
        bottom: 4rem;
      }
      .btn_bottom button {
        height: 4rem;
      }
    }
  `;

  const html = `
    <div class="root" id="test">
      <div className="content_wrapper">
        <div class="close_btn">
          <button class="close_btn_icon">close</button>
        </div>

        <div class="center">
          <div class="title_wrapper">
            <p class="year">${changeEnterHTML(text?.year_title)}</p>
            <h2 class="title">${changeEnterHTML(text?.title)}</h2>
            <p class="sub_title">${changeEnterHTML(text?.sub_title)}</p>
          </div>

          <div class="timer_area">
            <p class="countdown_text">${changeEnterHTML(
              text?.countdown_title
            )}</p>
            <ul class="timer" id="timer">
              <li>
                <div id="cDay" class="time">00</div>
                <div class="en">Hours</div>
              </li>
              <li class="margin">:</li>
              <li>
                <div id="cHour" class="time">00</div>
                <div class="en">Mins</div>
              </li>
              <li class="margin">:</li>
              <li>
                <div id="cMin" class="time">00</div>
                <div class="en">Secs</div>
              </li>
            </ul>
          </div>
        </div> 

        <div class="btn_bottom">
          <button class="style01">
            ${btnText?.button}
          </button>
        </div>
      </div>
    </div>
  `;

  let tracking_list = '[';
  for (let i = 0; i < tracking?.background?.length; i++) {
    tracking_list += `['${tracking?.background?.[i]}', '${tracking?.button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'BASIC FULL COUNTDOWN',
    button1,
    button2
  );

  const js = `
  document.addEventListener("DOMContentLoaded", function(){    
    
    const countdownTimer = function (id1, id2, id3, id4, date) {
      let _vData = date;
      let timer;

      function showRemaining() {
        let now = new Date();
        let distDt = _vData - now;

        if (distDt < 0) {
          clearInterval(timer);
          // 타이머 요소들을 숨기고 종료 메시지 표시
          document.getElementById(id1).style.display = 'none';
          document.getElementById(id2).style.display = 'none';
          document.getElementById(id3).style.display = 'none';
          $('.timer .margin').hide();
          $('.timer .en').hide();

          document.getElementById(id4).innerHTML = "종료되었습니다.";
          $("#" + id4).addClass("finish_ment");
          return;
        }

        let days = Math.floor(distDt / (1000 * 60 * 60 * 24));
        let hours = Math.floor(distDt / (1000 * 60 * 60));
        let minutes = Math.floor(distDt / (1000 * 60));
        let seconds = Math.floor(distDt / 1000);

        let d = days;
        let h = hours - days * 24;
        let m = minutes - hours * 60;
        let s = seconds - minutes * 60;

        let date = h + d * 24;
        document.getElementById(id1).textContent = date;
        document.getElementById(id2).textContent = m;
        document.getElementById(id3).textContent = s;
      }

      // 초기 실행으로 깜빡임 방지
      showRemaining();
      timer = setInterval(showRemaining, 1000)
    }

    countdownTimer("cDay", "cHour", "cMin", "timer", new Date(${
      text?.countdown?.year
    },${text?.countdown?.month - 1},${text?.countdown?.date},${
    text?.countdown?.hour
  },${text?.countdown?.min}))
    

      let tracking = ${tracking_list};
      let button1 = ${tracking_button_list[0]};
      let button2 = ${tracking_button_list[1]};
      $('.close_btn_icon').click(function() {
        appboyBridge.logClick(tracking[0][1]);
        try {
          if (button1[1].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[1].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
      $('.style01').click(function() {
        appboyBridge.logClick(tracking[0][0]);
        try {
          if (button1[0].indexOf(0) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[0].indexOf(0) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = '${deeplink?.background}';
      });
    });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
        <script src="https://code.jquery.com/jquery-3.6.0.min.js" />
        <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.js" />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default FullContdown;
